'use client'

import Link from 'next/link'
import { telHref } from '@/lib/format'
import { Home, Menu, Phone, Scales, Users } from './Icons'

/*
 * Phone par neeche chipki hui nav bar.
 *
 * Wajah: header ab bhi upar hai, par mobile par angootha screen ke neeche wale
 * hisse tak hi aaram se pahunchta hai. Isliye jo cheezein sabse zyada chahiye —
 * Home, About, Practice Areas, seedha call, aur poora menu — wo neeche ek hi
 * tap ki doori par hain.
 *
 * Baaki links (Our Profile, Team Profile, Internship, Contact us) "Menu" se
 * khulne wale drawer me hain, isliye yahan sirf paanch hi rakhe — usse zyada
 * rakhne par 360px chaudi screen par labels tootne lagte hain.
 *
 * Ye component sirf dikhata hai; menu khula hai ya nahi, ye state SiteHeader ke
 * paas rehti hai — taaki neeche wala "Menu" button aur upar wala hamburger,
 * dono ek hi drawer chalayein.
 */

type Props = {
  /** Header ka same phone number (DB se, Website_LexContact). */
  phone: string
  /** Drawer khula hai ya nahi — sirf aria-expanded ke liye. */
  open: boolean
  onMenuToggle: () => void
  isActive: (href: string) => boolean
}

const ITEMS = [
  { href: '/', label: 'Home', Icon: Home },
  { href: '/About', label: 'About', Icon: Users },
  { href: '/PracticeArea', label: 'Practice', Icon: Scales },
] as const

export default function MobileBottomBar({ phone, open, onMenuToggle, isActive }: Props) {
  return (
    <nav className="bottombar" aria-label="Quick links">
      <div className="bottombar__inner">
        {ITEMS.map(({ href, label, Icon }) => (
          <Link
            key={href}
            href={href}
            className="bottombar__item"
            aria-current={isActive(href) ? 'page' : undefined}
          >
            <Icon size={21} />
            <span className="bottombar__label">{label}</span>
          </Link>
        ))}

        <a href={telHref(phone)} className="bottombar__item bottombar__item--call">
          <Phone size={21} />
          <span className="bottombar__label">Call</span>
        </a>

        <button
          type="button"
          className="bottombar__item"
          aria-expanded={open}
          aria-controls="primary-nav"
          onClick={onMenuToggle}
        >
          <Menu size={21} />
          <span className="bottombar__label">Menu</span>
        </button>
      </div>
    </nav>
  )
}
